const GENERIC_ERROR_MSG = 'Something went wrong. Please try again later';
export default GENERIC_ERROR_MSG;
